import SectionRenderer from './SectionRenderer';

const DashboardLayout = ({ sections }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      {sections.map(section => (
        <SectionRenderer key={section.id} section={section} />
      ))}
    </div>
  );
};

export default DashboardLayout